import type { INavData } from '@coreui/angular-pro';

export const navItemsMedic: INavData[] = [
  {
    name: 'Home',
    url: '/dashboard',
    iconComponent: { name: 'cil-home' },
  },
  {
    name: 'Pacientes',
    url: '/patient',
    iconComponent: { name: 'cil-people' },
    children: [
      {
        name: 'Vincular paciente',
        url: '/patient/search',
      },
      {
        name: 'Listado de pacientes',
        url: '/patient/list',
      },
    ],
  },
  {
    name: 'Órdenes',
    iconComponent: { name: 'cil-clipboard' },
    children: [
      {
        name: 'ERKOM',
        url: 'erkom/list',
      },
      {
        name: 'FMF',
        url: 'fmf/list',
      },
    ],
  },

];
